module.exports = __webpack_public_path__ + "static/media/bloom.b52f09cb.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/coins/bloom.svg
// module id = 1147
// module chunks = 0